<template>
  <div class="manual-text">
    <h1 class="text-center mt-2 mb-10">PPI Analysis</h1>
    <p>The first analysis that is performed is called Project Performance Index (PPI) analysis
      and is based on the Project Success Indicators (PSIs), which are metrics that are used to
      assess the successful (or not) implementation of each project’s interventions and their
      impact against pre-defined targets relevant to this specific project. </p>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
